import { useNavigate } from "react-router-dom";
import styles from "../Configurations.module.css";

const ConfigurationsDashboard = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.dashboard}>
            <div className={styles.configGrid}>
                <div className={styles.configCard}>
                    <h3>General Settings</h3>
                    <p>Configure general system settings like note types and other global features</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/general')}
                    >
                        General Settings
                    </button>
                </div>

                <div className={styles.configCard}>
                    <h3>User Management</h3>
                    <p>Manage user accounts, roles, and permissions</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/users')}
                    >
                        Configure Users
                    </button>
                </div>
                
                <div className={styles.configCard}>
                    <h3>System Settings</h3>
                    <p>Configure global system parameters and preferences</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/system')}
                    >
                        Configure System
                    </button>
                </div>
                
                <div className={styles.configCard}>
                    <h3>Lab Settings</h3>
                    <p>Configure laboratory-specific settings and workflows</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/lab')}
                    >
                        Configure Lab
                    </button>
                </div>
                
                <div className={styles.configCard}>
                    <h3>Security Settings</h3>
                    <p>Manage authentication, encryption, and access controls</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/security')}
                    >
                        Configure Security
                    </button>
                </div>

                <div className={styles.configCard}>
                    <h3>QA Settings</h3>
                    <p>Configure quality assurance protocols and standards</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/qa')}
                    >
                        Configure QA
                    </button>
                </div>

                <div className={styles.configCard}>
                    <h3>Client Settings</h3>
                    <p>Manage client-specific configurations</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/clients')}
                    >
                        Configure Clients
                    </button>
                </div>

                <div className={styles.configCard}>
                    <h3>QuickBooks Integration</h3>
                    <p>Connect to QuickBooks for automated invoicing</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/quickbooks')}
                    >
                        Configure QuickBooks
                    </button>
                </div>

                <div className={styles.configCard}>
                    <h3>Client Onboarding</h3>
                    <p>Create onboarding links and test the client registration process</p>
                    <button 
                        className={styles.configButton}
                        onClick={() => navigate('/configurations/onboarding')}
                    >
                        Manage Onboarding
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfigurationsDashboard;
